import { useEffect, useState } from 'react';
import { apiClient } from '../lib/api-client';

export function useAuth() {
  const [user, setUser] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [isSignedIn, setIsSignedIn] = useState(false);

  const fetchUser = async () => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
      setLoading(false);
      return;
    }

    try {
      const response = await apiClient.get('/me');
      setUser(response.data);
      setIsSignedIn(true);
    } catch (error) {
      console.error('Auth check failed:', error);
      localStorage.removeItem('auth_token');
      setUser(null);
      setIsSignedIn(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const login = async (credentials: any) => {
    setLoading(true);
    try {
      const response: any = await apiClient.post('/login', credentials);
      localStorage.setItem('auth_token', response.data.access_token);
      setUser(response.data.user);
      setIsSignedIn(true);
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const register = async (payload: any) => {
    setLoading(true);
    try {
      const response: any = await apiClient.post('/register', payload);
      if (response?.data?.access_token) {
        localStorage.setItem('auth_token', response.data.access_token);
      }
      if (response?.data?.user) {
        setUser(response.data.user);
        setIsSignedIn(true);
      }
      return response.data;
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    setLoading(true);
    try {
      await apiClient.post('/logout');
    } catch (error) {
      console.error('Logout failed:', error);
    } finally {
      localStorage.removeItem('auth_token');
      setUser(null);
      setIsSignedIn(false);
      setLoading(false);
    }
  };

  const mappedUser = user
    ? {
        id: user.id,
        email: user.email,
        name: user.name as string,
        full_name: user.name as string,
        avatar: (user.avatar_url || `https://ui-avatars.com/api/?name=${user.name}`) as string,
        avatar_url: (user.avatar_url || `https://ui-avatars.com/api/?name=${user.name}`) as string,
      }
    : null;

  return {
    user: mappedUser as NonNullable<typeof mappedUser>,
    loading,
    isSignedIn,
    login,
    register,
    logout,
    refreshUser: fetchUser,
  };
}
